"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconContactByEmail = function IconContactByEmail(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M21.234 5.97 19.85 4.586 6.418 18.017 8 19.525v7.39l1 1V28h.085L23 41.924v.046h.046l.934.934.934-.934H25v-.086L43.914 22.97H44v-.086l.934-.934-.934-.934v-.046h-.046L30 7.016V7h-.016l-1.03-1.03zm2 2L28 12.736V7.969zM28 15.564l-8.15-8.149L9.282 17.982 17.702 26h7.336a3 3 0 0 0 2.957-2.825L28 23zM14.801 26 10 21.428V26zM30 9.845 41.125 20.97H32v2h9.085L25 39.054V28h.05l.216-.007A5 5 0 0 0 30 23zM23 28v11.095L11.913 28zm-5.014-15.734.707.707-5.7 5.7-.707-.707zm1.387 3.408-.707-.708-4.69 4.69.707.707z",
    clipRule: "evenodd"
  })));
};

export { IconContactByEmail, IconContactByEmail as default };
